export type MappedRecursiveToType<T, V> = {
    [P in keyof T]-?: Exclude<T[P], undefined> extends unknown[] // If its an array set the array to the type.
        ? V
        : // If it is an extension of the type, set it the the type
          Exclude<T[P], undefined> extends V
          ? V
          : // If its an object, recursively set the object to the type

            Exclude<T[P], undefined> extends object
            ? MappedRecursiveToType<T[P], V>
            : // Otherwise it must be the type
              V;
};

function isMappedRecursiveToTypeOrString<T, V>(obj: any): obj is MappedRecursiveToType<T, V> {
    return typeof obj !== 'string';
}

export function convertRecursiveToDotNotation<T, V>(
    recursiveObject: MappedRecursiveToType<T, V>,
    dotChar = '.',
): Record<string, V> {
    const all: Record<string, V> = {};
    for (const key of Object.keys(recursiveObject)) {
        const value: MappedRecursiveToType<V, V> | V = recursiveObject[key as keyof typeof recursiveObject] as
            | MappedRecursiveToType<V, V>
            | V;
        if (isMappedRecursiveToTypeOrString<V, V>(value)) {
            const subValues = convertRecursiveToDotNotation(value, dotChar);
            for (const subKey of Object.keys(subValues)) {
                all[`${key}${dotChar}${subKey}`] = subValues[subKey];
            }
        } else {
            all[key] = value;
        }
    }
    return all;
}
